/*

  分别是并行和串行

  parallel([
    function(resolve, reject) {
      setTimeout(function() {
        resolve(1)
      }, 200)
    },
    function(resolve, reject) {
      setTimeout(function() {
        resolve(2)
      }, 100)
    }
  ])
    .then(res => console.log(res))
    .catch(err => console.log(err))
*/

export function parallel(tasks = []) {
    return new Promise((resolve, reject) => {
        if (!Array.isArray(tasks)) return reject('require array')
        const tasksLength = tasks.length
        if (tasksLength === 0) return reject('require not empty array')

        const callbackData = []
        let resolveCount = 0

        tasks.forEach((cb, i) => {
            cb(payload => _resolve(payload, i), _reject, i)
        })

        function _resolve(payload, i) {
            callbackData[i] = payload
            resolveCount++
            if (resolveCount >= tasksLength) resolve(callbackData)
        }

        function _reject(msg) {
            reject(msg)
        }
    })
}

export function series(tasks = []) {
    return new Promise((resolve, reject) => {
        if (!Array.isArray(tasks)) return reject('require array')
        const tasksLength = tasks.length
        if (tasksLength === 0) return reject('require not empty array')

        const callbackData = []
        let resolveIndex = 0

        runTasks()
        function runTasks() {
            tasks[resolveIndex](_resolve, _reject)
        }

        function _resolve(payload) {
            callbackData.push(payload)
            resolveIndex++
            if (resolveIndex >= tasksLength) {
                resolve(callbackData)
            } else {
                runTasks()
            }
        }

        function _reject(msg) {
            reject(msg)
        }
    })
}



// WEBPACK FOOTER //
// ./src/utils/async.js